import { Authority } from '@/shared/security/authority';

const ChangePassword = () => import('@/account/change-password/change-password.vue');
const Settings = () => import('@/account/settings/settings.vue');
const Firmsettings = () => import('@/account/firmsettings/firmsettings.vue');
const Stammdaten = () => import('@/account/firmsettings/stammdaten.vue');

export default [
  {
    path: '/account/password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/account/settings',
    name: 'Settings',
    component: Settings,
    meta: { authorities: [Authority.USER] },
  },
  {
    path: '/account/firmsettings',
    name: 'Firmsettings',
    component: Firmsettings,
    meta: { authorities: [Authority.CHEF, Authority.BUCHHALTUNG] },
  },
  {
    path: '/account/stammdaten',
    name: 'Stammdaten',
    component: Stammdaten,
    meta: { authorities: [Authority.CHEF, Authority.BUCHHALTUNG] },
  },
];
